import { AlertTriangle } from "lucide-react";

export function Panel({ title, children, className = "", action }) {
  return (
    <section className={`rounded-[20px] border border-[rgba(181,148,82,.5)] bg-white/60 p-5 sm:p-6 ${className}`}>
      {(title || action) && (
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          {title && <h2 className="font-display text-2xl font-semibold text-[var(--emerald)]">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Missing({ items }) {
  if (!items?.length) return null;
  return (
    <div className="rounded-[20px] border border-[var(--marigold)] bg-[#FCE9C8] p-5" data-testid="host-missing-config">
      <p className="flex items-center gap-2 font-semibold"><AlertTriangle className="h-5 w-5" aria-hidden="true" /> Still to configure</p>
      <ul className="mt-2 list-disc space-y-1 pl-6 text-sm">
        {items.map((m) => <li key={m}>{m}</li>)}
      </ul>
    </div>
  );
}

function Stat({ label, value, sub, testid }) {
  return (
    <div className="rounded-[20px] border border-[rgba(181,148,82,.5)] bg-[var(--ivory)] p-5" data-testid={testid}>
      <p className="eyebrow">{label}</p>
      <p className="font-display mt-1 text-5xl font-semibold text-[var(--emerald)]">{value ?? 0}</p>
      {sub && <p className="text-sm text-[#3d5a51]">{sub}</p>}
    </div>
  );
}

export default function HostOverview({ eventData, rsvps, photos }) {
  const s = rsvps.stats || {};
  const diet = (rsvps.items || []).filter((r) => r.dietary);
  const pending = photos.filter((p) => !p.approved).length;
  return (
    <div className="flex flex-col gap-6">
      <Missing items={eventData?.missing} />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Confirmed people" value={s.attendees} sub="incl. additional guests" testid="stat-attendees" />
        <Stat label="Attending" value={s.yes} sub="RSVPs" testid="stat-yes" />
        <Stat label="Maybe" value={s.maybe} sub={`${s.maybe_people || 0} people if they come`} testid="stat-maybe" />
        <Stat label="Declined" value={s.no} testid="stat-no" />
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Dietary notes">
          {diet.length ? (
            <ul className="divide-y divide-[rgba(181,148,82,.35)]" data-testid="dietary-list">
              {diet.map((r) => <li key={r.id} className="py-2"><span className="font-semibold">{r.name}</span> <span className="text-sm">({r.party_size})</span>: {r.dietary}</li>)}
            </ul>
          ) : <p className="text-sm">No dietary notes yet.</p>}
        </Panel>
        <Panel title="At a glance">
          <ul className="space-y-1">
            <li>{photos.length} photo{photos.length === 1 ? "" : "s"} on the wall{pending ? ` · ${pending} awaiting approval` : ""}</li>
          </ul>
        </Panel>
      </div>
    </div>
  );
}
